import React from 'react';
import HeroDe from '../components/de/Hero';
import ShopByCategoryDe from '../components/de/ShopByCategory';
import CategoryTabsDe from '../components/de/CatogoryProduct';
import ProductListDe from '../components/de/ProductList';

const HomeDe = () => {
  return (
    <div className="container-fluid">
      <HeroDe />
      <ShopByCategoryDe />
      <CategoryTabsDe />
      <ProductListDe />
    </div>
  );
};

export default HomeDe;
